<template>
    <va-create-layout>
        <ServiceFeeEvent-form
            :title="title"
            :item="item"
        ></ServiceFeeEvent-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
